import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/archive";

const links = [
  { to: "/", label: "首页", end: true },
  { to: "/archive", label: "考古档案", end: false },
  { to: "/about", label: "关于我们", end: false },
  { to: "/contact", label: "联系我们", end: false },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || location.pathname !== "/";

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-300"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 font-heading text-lg rounded-md group-hover:bg-primary-600 transition-colors">
            溯
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-wide">
              {siteInfo.brand}
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-600 tracking-[0.18em]">
              网络言行回溯档案
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {links.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-primary-600 font-medium bg-primary-50"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            className="ml-3 px-4 py-2 text-sm rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            提交线索
          </Link>
        </nav>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 border border-background-300 bg-background-50"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-300 bg-background-50">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {links.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md ${
                    isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 px-3 py-3 text-sm rounded-md bg-foreground-950 text-background-50 text-center whitespace-nowrap"
            >
              提交线索
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}